import { render, staticRenderFns } from "./InterfaceBalanceModal.vue?vue&type=template&id=ccf4f3a4&scoped=true&"
import script from "./InterfaceBalanceModal.vue?vue&type=script&lang=js&"
export * from "./InterfaceBalanceModal.vue?vue&type=script&lang=js&"
import style0 from "./InterfaceBalanceModal.vue?vue&type=style&index=0&id=ccf4f3a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf4f3a4",
  null
  
)

export default component.exports